import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getDealersTransporters } from '@/api/dealers-transporters';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import Inr from '@/components/Inr/index.vue';
import { isExcludedToAccess } from '@/common';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.dealerId = 0;
    this.listQuery = {
      page: 1,
      limit: 10,
      dealerId: 0,
      enabled: true,
      sort: 'id,ASC',
      filter: {
        enabled: '$eq',
        dealerId: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.dealerId = parseInt(this.$route.params && this.$route.params.dealerId);
    this.listQuery = {
      ...this.listQuery,
      ...this.$route.query
    };
    this.getList();
  }
  hasNoAccess(requiredRoles) {
    return isExcludedToAccess(requiredRoles);
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.dealerId = this.dealerId;
      const data = await getDealersTransporters(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  sortChange(data) {
    this.handleFilter();
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'fullname', 'email', 'contact', 'role'];
    const filterVal = ['id', 'fullName'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.userManagement.users.title'));
    this.downloadLoading = false;
  }
};
default_1 = __decorate([Component({
  name: 'DealersTransporterList',
  components: {
    Pagination,
    Enabled,
    Inr
  }
})], default_1);
export default default_1;